

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class NotificationIcon extends Vue {
  @Prop({required: true}) icon: any;
  @Prop({default: 0}) num: any;
  @Prop({required: true}) tooltip: any;

  get isLargeMode() {
    return this.$store.getters['isLargeMode'];
  }
}
